<template>
  <div class="container-custom">
    <Breadscrumbs
      :links="[
        { name: 'Human Resource', to: { path: '/human-resource' } },
        { name: 'Resume Edit', to: { path: '/human-resource/resume-edit' } },
      ]"
    ></Breadscrumbs>
    <div class="page-actions">
      <h2>編輯求職者資料</h2>
      <v-spacer></v-spacer>
      <button class="btn mr-5" @click="cancelHandler">取消</button>
      <button class="btn btn-primary" @click="saveHandler">儲存</button>
    </div>
    <!--  -->
    <ResumeEditCreate></ResumeEditCreate>
  </div>
</template>

<script>
import Breadscrumbs from '@/components/Breadscrumbs.vue';
import ResumeEditCreate from '@/views/J__HR/c/ResumeEditCreate.vue';

export default {
  components: {
    Breadscrumbs,
    ResumeEditCreate,
  },
  methods: {
    cancelHandler() {
      this.$router.push('/human-resource');
    },
    saveHandler() {
      this.$router.push('/human-resource');
    },
  },
};
</script>

<style></style>
